export const transformHoursToDays = (hours: number): string => {
  const hoursInDay = 24;
  const days = Math.floor(hours / hoursInDay);
  const hoursRest = hours - hoursInDay * days;

  if (hoursRest) {
    return `${days} д. ${hoursRest} ч.`;
  } else {
    return `${days} д.`;
  }
};
